import tw from 'tailwind-styled-components'

export const DropArea = tw.div<{$isDragEnter: boolean}>`
  relative
  flex
  flex-col
  justify-center
  items-center
  border-1
  hover:border-action-default
  w-full
  border-dashed
  rounded-4
  h-128
  ${p =>
    p.$isDragEnter
      ? 'bg-main-even-old border-action-default'
      : 'border-lists-divider-old'}
`

export const MainMsg = tw.div<{$marginBottom?: boolean}>`
  flex
  flex-row
  text-action-default
  items-center
  font-medium
  text-18
  ${p => (p.$marginBottom ? 'mb-12' : '')}
`

export const SecondMsg = tw.div`
  text-14
  text-third-old
`
